<template>
    <div>
         <con-tab @TwoClick="TwoClick"></con-tab>
       <!-- 科服云动态列表 -->
        <Dynamic-Nei ></Dynamic-Nei>
    </div>
</template>

<script>
    import ConTab from "../../components/common/ConTab";
    import DynamicNei from "./base/DynamicNei";
    // import Qs from 'qs'
    export default {
        name: "Dynamic",
        data(){
            return {
                
            }
        },
        created(){
            
        },
        methods:{
             TwoClick(item){
                //console.log(item);
                this.ConList = item
            },
        },
        components:{
            ConTab,
            DynamicNei
        }
    }
</script>

<style scoped>

</style>
